import type {WsRecipient} from "../ws/WsRecipient.ts";
import {CtiBox} from "./CtiBox.js";
import crmWS from "../ws/UniversalSocket.ts";


export class CtiWsRecipient implements WsRecipient {

	constructor(element, onLoadData) {
		this.infobox = element;
		crmWS.register("cti", this);
		this.clientBoxes = new Map();
		this.install(onLoadData); //???
	}

	install(onLoadData) {
		/*
		* generovat aktualni stav vsech volani
		*/
		let ctiPanel = document.getElementById('cti_client');
		for(let callInfo of onLoadData) {
			var ctiBox = new CtiBox(callInfo);
			ctiPanel.appendChild(ctiBox.toElement());
			this.clientBoxes.set(callInfo.uid, ctiBox);
		}
	}

	onMessage(sender, message) { //novy box, nebo pozmeneny jiz existujici
		//console.log("Type je "+(typeof message)+" je to pole "+Array.isArray(message));
		for(let serverCallInfo of message) {
			if(this.clientBoxes.has(serverCallInfo.uid)) {
				var oldCallInfo = this.clientBoxes.get(serverCallInfo.uid).getCallInfo();
				this.compareBoxes(serverCallInfo, oldCallInfo);
			} else {
				let ctiPanel = document.getElementById('cti_client');
				var ctiBox = new CtiBox(serverCallInfo);
				ctiPanel.appendChild(ctiBox.toElement());
				this.clientBoxes.set(serverCallInfo.uid, ctiBox);
			}
		}

		//remove old boxes
		if(this.clientBoxes.size>message.length) {
			//console.log('ze serveru prislo mene boxu... ');
			var toDeleteUids = [];
			for(let clientCtiBox of this.clientBoxes) {
				var deleteBox = true;
				for(let serverCallInfo of message) {
					if(serverCallInfo.uid===clientCtiBox[0]) deleteBox = false;
				}
				if(deleteBox) {
					clientCtiBox[1].stopClock();
					clientCtiBox[1].divBox.remove();
					toDeleteUids.set(clientCtiBox[0]);
				}
			}
			if(toDeleteUids.length>0) {
				for(let id of toDeleteUids) {
					this.clientBoxes.delete(id);
				}
			}
		}
	}

	onOpen() {}

	onClose() {}



	compareBoxes(newInfo, oldInfo)
	{
		if(oldInfo.call_state!==newInfo.call_state) {
			CtiBox.changeState(newInfo, oldInfo);

			if(newInfo.call_state === 2) {
				//console.log('trying start clock');
				var ctiBox = this.clientBoxes.get(newInfo.uid);
				ctiBox.setNewCallInfo(newInfo);
				ctiBox.startClock();
			} else if(newInfo.call_state === 4) {
				//console.log('trying stop clock');
				var ctiBox = this.clientBoxes.get(newInfo.uid);
				ctiBox.stopClock();
			}
		}
	}
}

